import React, { useEffect, useState } from "react";
import {
  ArrowBack,
  Favorite,
  FavoriteBorder,
  FilterAlt,
  FilterList,
  Sort,
} from "@mui/icons-material";
import {
  Divider,
  Button,
  Rating,
  Drawer,
  Card,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  Tabs,
  Tab,
  Skeleton,
  Pagination,
  List,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import classNames from "classnames";
import Checkout from "../../Checkout";
import { productsFn } from "../../../Services/Products/ProductList";
import WishlistButton from "../../../Shared/WishlistButton";
import { addToWishListFn } from "../../../Services/Products/AddToWishlist";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../Redux/Actions/SnackBar";
import SearchModal from "../../../Shared/Search";
import { categoriesFn } from "../../../Services/Home/Categories";
import { allFiltersFn } from "../../../Services/Products/AllFilters";

const ProductList = () => {
  const { state } = useLocation();
  const [open, setOpen] = useState({ sort: false, filter: false });
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const handleClose = () => {
    setOpen({ sort: false, filter: false });
  };
  const navigate = useNavigate();

  const { mutate: allProducts, isLoading } = useMutation(productsFn, {
    onSuccess: (res) => {
      setData(res?.data?.data?.product_list);
    },
  });
  useEffect(() => {
    state?.title === "All Products" && allProducts({ page: page });
  }, [state?.title]);

  const { isLoading: isLoadingFilter } = useQuery(
    ["filters", page, state?.categoryId],
    () =>
      state?.from === "category" &&
      allFiltersFn({
        category_id: state?.categoryId,
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        max_discount: "",
        min_discount: "",
        rating: "",
      }),
    {
      onSuccess: (res) => {
        setData(res?.data?.data?.product_list);
      },
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { isLoading: isLoadingPrice } = useQuery(
    ["filters", page, state?.min_price],
    () =>
      state?.from === "price" &&
      allFiltersFn({
        page: page,
        category_id: "",
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: state?.max_price,
        min_price: state?.min_price,
        max_discount: "",
        min_discount: "",
        rating: "",
      }),
    {
      onSuccess: (res) => {
        setData(res?.data?.data?.product_list);
      },
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { isLoading: isLoadingDiscount } = useQuery(
    ["filters", page, state?.min_discount],
    () =>
      state?.from === "discount" &&
      allFiltersFn({
        page: page,
        category_id: "",
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        max_discount: state?.max_discount,
        min_discount: state?.min_discount,
        rating: "",
      }),
    {
      onSuccess: (res) => {
        setData(res?.data?.data?.product_list);
      },
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  // console.log(allFilters);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <Typography>{children}</Typography>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    sessionStorage.setItem("page", value);
  };
  const client = useQueryClient();
  const dispatch = useDispatch();
  const { mutate: addToWishlist } = useMutation(addToWishListFn, {
    onSuccess: (response) => {
      dispatch(
        setSnackbar({
          open: true,
          message: response?.data?.status,
          variant: "success",
        })
      );
      response.data.status === "Product added to wishlist" &&
        client.refetchQueries("myWishList");
      response.data.status === "Product added to wishlist" &&
        client.refetchQueries("filters");
    },
  });
  const handleAddToWishlist = (event, variant_id) => {
    event.stopPropagation();
    addToWishlist({
      add_quantity: 1,
      product_id: variant_id,
    });
  };
  const handleLogin = (event) => {
    event.stopPropagation();
    navigate("/login");
  };
  const { data: categories, isLoading: isLoadingCategories } = useQuery(
    ["categories"],
    () => categoriesFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [page]);

  return (
    <div className="flex flex-col">
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl w-48 overflow-hidden text-ellipsis whitespace-nowrap">
            {state?.title}
          </p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>

      <div className="fixed w-full bg-white dark:bg-zinc-900 z-50 flex mt-16 shadow">
        <Button
          variant="text"
          color="inherit"
          startIcon={<Sort />}
          onClick={() => setOpen({ sort: true, filter: false })}
          className="w-full !p-3 !rounded-none !capitalize !text-base"
        >
          Sort
        </Button>
        <div className="border border-zinc-200 dark:border-zinc-700"></div>
        <Button
          variant="text"
          color="inherit"
          startIcon={!state?.categoryName && <FilterAlt />}
          onClick={() => setOpen({ sort: false, filter: true })}
          className="w-full !p-3 !rounded-none !capitalize !text-base"
        >
          Filters
        </Button>
      </div>

      <div className="flex-col flex px-2 mb-16 mt-28">
        <div className="border border-zinc-200 dark:border-zinc-700 rounded" />
        {isLoadingFilter || isLoading || isLoadingPrice || isLoadingDiscount ? (
          <div className="grid grid-cols-2 gap-[2px]">
            {[1, 2, 3, 4, 5, 6].map(() => {
              return (
                <Card
                  elevation={0}
                  className="!p-2 text-xs flex flex-col gap-2 !rounded-none !shadow !cursor-pointer"
                >
                  <Skeleton variant="rectangular" width={175} height={175} />

                  <Skeleton />
                  <Skeleton width="60%" />
                  <Skeleton />
                  <Skeleton>
                    <Rating />
                  </Skeleton>
                </Card>
              );
            })}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-[2px]">
            {data?.map((product) => {
              return (
                <Card
                  elevation={0}
                  className="!p-2 !rounded-none !shadow"
                  onClick={() =>
                    navigate(`/product/${product.id}/${product.slug}`)
                  }
                >
                  <div className="flex">
                    <img
                      src={product.variant_image}
                      alt=""
                      width={175}
                      height={175}
                    />
                    <span
                      onClick={(event) =>
                        localStorage.getItem("bhaarattoken")
                          ? handleAddToWishlist(event, product.variant_id)
                          : handleLogin(event)
                      }
                    >
                      {product.whishlist_status === "No" ? (
                        <FavoriteBorder className="-ml-8 shadow mt-1 p-1 !text-3xl dark:!text-zinc-600 bg-white border-zinc-200 dark:bg-zinc-900 rounded-full" />
                      ) : (
                        <Favorite
                          color="primary"
                          className="-ml-8 shadow mt-1 p-1 !text-3xl bg-white dark:bg-zinc-900 rounded-full"
                        />
                      )}
                    </span>
                  </div>
                  <div className="flex flex-col gap-1 p-1 py-2">
                    <p className="text-sm w-40 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <span className="flex text-xs items-center gap-1">
                      <p
                        className={classNames(
                          "line-through",
                          product.discount_percent === "0.0" ? "hidden" : ""
                        )}
                      >
                        {product.price}
                      </p>
                      <p className="font-semibold"> ₹{product.actual_price}</p>
                      <span
                        className={classNames(
                          "text-green-700",
                          product.discount_percent === "0.0" ? "hidden" : ""
                        )}
                      >
                        {product.discount_percent}% off
                      </span>
                    </span>

                    <div className="flex py-2 w-full">
                      <div className="flex text-center flex-col bg-[#DEFEDA] rounded-r-md py-1">
                        <div className="border-r text-xs border-dashed border-green-500 text-black py-1 px-2">
                          <p>₹{product.actual_price / 10}</p>
                        </div>
                      </div>
                      <div className="flex justify-center bg-[#DEFEDA] items-center rounded-l-md w-full">
                        <p className="text-xs font-semibold">
                          Coupon Available
                        </p>
                      </div>
                    </div>
                    <Rating
                      value={product.rating}
                      size="small"
                      readOnly
                      precision={0.5}
                      className="!text-green-700"
                    />
                  </div>
                </Card>
              );
            })}
          </div>
        )}

        {data?.length > 24 && (
          <div className="py-4 flex justify-center items-center w-full">
            <Pagination
              count={data?.length || 0}
              page={Number(sessionStorage.getItem("page")) || page}
              variant="outlined"
              color="primary"
              size="medium"
              onChange={handlePageChange}
            />
          </div>
        )}
      </div>
      <Drawer open={open.sort} anchor="bottom" onClose={handleClose}>
        <div className="flex flex-col">
          <p className="p-3">SORT BY</p>
          <Divider />
          <FormControl fullWidth className="!py-3">
            <RadioGroup
              aria-labelledby="demo-form-control-label-placement"
              name="position"
              defaultValue="top"
              className="w-full"
            >
              <FormControlLabel
                value="top"
                control={<Radio />}
                label="Popularity"
                labelPlacement="start"
                className="flex justify-between w-full !m-0 px-3"
              />
              <FormControlLabel
                value="start"
                control={<Radio />}
                label="Price -- Low to High"
                labelPlacement="start"
                className="flex justify-between w-full !m-0 px-3"
              />
              <FormControlLabel
                value="bottom"
                control={<Radio />}
                label="Price -- High to Low"
                labelPlacement="start"
                className="flex justify-between w-full !m-0 px-3"
              />
              <FormControlLabel
                value="end"
                control={<Radio />}
                label="Newest First"
                labelPlacement="start"
                className="flex justify-between w-full !m-0 px-3"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </Drawer>
      <Drawer
        open={open.filter}
        anchor="right"
        onClose={handleClose}
        PaperProps={{ className: "w-5/6" }}
      >
        <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
          <span className="flex gap-5 items-center">
            <ArrowBack onClick={() => handleClose()} />
            <p className="text-xl">Filters</p>
          </span>
        </div>

        <Box className="flex h-full pt-16">
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleChange}
            sx={{ borderRight: 1, borderColor: "divider" }}
          >
            <Tab
              className="!capitalize !items-start w-36"
              label="Categories"
              {...a11yProps(0)}
            />
            <Tab
              className="!capitalize !items-start w-36"
              label="Price"
              {...a11yProps(1)}
            />
            <Tab
              className="!capitalize !items-start w-36"
              label="Discount"
              {...a11yProps(2)}
            />
          </Tabs>

          <TabPanel
            value={value}
            index={0}
            className="!m-0 !h-[85vh] hide-scroll !overflow-y-auto"
          >
            <List>
              {categories?.data?.data?.main_category_list?.map(
                (item, index) => {
                  return (
                    <ListItemButton
                      onClick={() => {
                        navigate("/all-products", {
                          state: {
                            from: "category",
                            categoryId: item.id,
                            title: item.category,
                          },
                        });
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <img
                          src={item.image}
                          alt=""
                          className="rounded-full h-10 w-10"
                        />
                      </ListItemIcon>
                      {item.category}
                    </ListItemButton>
                  );
                }
              )}
            </List>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <List>
              {[
                {
                  id: 1,
                  title: "Less than ₹1000",
                  min_price: 1,
                  max_price: 1000,
                },
                {
                  id: 2,
                  title: "₹1000 to ₹2000",
                  min_price: 1000,
                  max_price: 2000,
                },

                {
                  id: 3,
                  title: "₹2000 to ₹5000",
                  min_price: 2000,
                  max_price: 5000,
                },
                {
                  id: 4,
                  title: "₹5000 to ₹10000",
                  min_price: 5000,
                  max_price: 10000,
                },
                {
                  id: 5,
                  title: "₹10000 to ₹15000",
                  min_price: 10000,
                  max_price: 15000,
                },
                {
                  id: 6,
                  title: "₹15000 to ₹20000",
                  min_price: 15000,
                  max_price: 20000,
                },
                {
                  id: 7,
                  title: "₹20000 to ₹50000",
                  min_price: 20000,
                  max_price: 50000,
                },
                {
                  id: 8,
                  title: "₹50000 to ₹70000",
                  min_price: 50000,
                  max_price: 70000,
                },
                {
                  id: 9,
                  title: "₹70000 to ₹100000",
                  min_price: 70000,
                  max_price: 100000,
                },
                {
                  id: 10,
                  title: "More Than 100000",
                  min_price: 100000,
                  max_price: 1000000,
                },
              ].map((item) => {
                return (
                  <ListItemButton
                    onClick={() => {
                      navigate("/all-products", {
                        state: {
                          from: "price",
                          title: item.title,
                          min_price: item.min_price,
                          max_price: item.max_price,
                        },
                      });
                      handleClose();
                    }}
                  >
                    {item.title}
                  </ListItemButton>
                );
              })}
            </List>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <List>
              {[
                {
                  id: 1,
                  title: "10% or more",
                  min_discount: 10,
                  max_discount: 100,
                },
                {
                  id: 2,
                  title: "20% or more",
                  min_discount: 20,
                  max_discount: 100,
                },

                {
                  id: 3,
                  title: "30% or more",
                  min_discount: 30,
                  max_discount: 100,
                },
                {
                  id: 4,
                  title: "40% or more",
                  min_discount: 40,
                  max_discount: 100,
                },
                {
                  id: 5,
                  title: "50% or more",
                  min_discount: 50,
                  max_discount: 100,
                },
                {
                  id: 5,
                  title: "60% or more",
                  min_discount: 60,
                  max_discount: 100,
                },
              ].map((item) => {
                return (
                  <ListItemButton
                    onClick={() => {
                      navigate("/all-products", {
                        state: {
                          from: "discount",
                          title: item.title,
                          min_discount: item.min_discount,
                          max_discount: item.max_discount,
                        },
                      });
                      handleClose();
                    }}
                  >
                    {item.title}
                  </ListItemButton>
                );
              })}
            </List>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <div className="py-2">
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 219 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
            </div>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <div className="py-2">
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 219 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
            </div>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <div className="py-2">
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 299 and below</p>
              <p className="py-3 px-8">Rs 219 and below</p>
            </div>
          </TabPanel>
        </Box>
      </Drawer>
    </div>
  );
};

export default ProductList;
